import React, { useState, useEffect } from "react";
import "./MealCalorie.css";
import Loading from "../../../Components/Loading/Loading";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import { MdArrowForwardIos } from "react-icons/md";
import { MdArrowBackIos } from "react-icons/md";
import FoodModal from "../../../Components/FoodModal/FoodModal";
import { MdSearch } from "react-icons/md";
import AddIcon from "@mui/icons-material/Add";
import MealsData from "../Meals/MealsData";
import { useParams, useLocation } from "react-router-dom";
import Alert from "../../../Components/Alert/Alert";
import { FiEdit2 } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import { useAuth } from "../../../AuthContext";
import Axios from "axios";
import { Outlet, useNavigate } from "react-router-dom";
import { useBaseUrl } from "../../../ApiContext";

export default function MealCalorie() {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { date, mealLabel } = location.state || {};
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [showMealEditModal, setShowMealEditModal] = useState(false);
  const [shamsiDate, setShamsiDate] = useState(null);
  const [activeMealData, setActiveMealData] = useState(
    MealsData.filter((meal) => meal.id == params.id)
  );
  const [mealData, setMealData] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [units, setUnits] = useState(null);
  const [activeUnitId, setActiveUnitId] = useState(null);
  const [activeMealName, setActiveMealName] = useState(null);
  const [mainId, setMainId] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [editInitAmount, setEditInitAmount] = useState(0);
  const [alertText, setAlertText] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const prevMealHandler = () => {
    const prevMeal = MealsData.filter(
      (meal) => meal.id === activeMealData[0].id - 1
    );
    if (prevMeal.length) {
      setActiveMealData(prevMeal);
    }
  };

  const handleActiveUnitId = (unitId) => {
    setActiveUnitId(unitId);
  };

  const nextMealHandler = () => {
    const nextMeal = MealsData.filter(
      (meal) => meal.id === activeMealData[0].id + 1
    );
    if (nextMeal.length) {
      setActiveMealData(nextMeal);
    }
  };

  const openFoodListHandler = () => {
    navigate("foodList", { state: { shamsiDate: date, label: mealLabel } });
  };

  const handleShowEditModal = async (meal) => {
    if (selectedMeals.length > 0) {
      setShowMealEditModal(true);
      setMealData(meal.food);
      setActiveMealName(meal.meal_name);
      setMainId(meal.id);
      setActiveUnitId(meal.unit.id);
      setEditInitAmount(parseFloat(meal.amount));
    }
  };

  useEffect(() => {
    const fetchModalData = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/food_list/${mealData.id}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setUnits(response.data.units);
      } catch (error) {
        console.log("Error during getting food data", error);
      }
    };
    if (userToken && mealData) {
      fetchModalData();
    }
  }, [baseUrl, userToken, mealData]);

  const handleHideEditModal = () => {
    setShowMealEditModal(false);
  };

  const fetchSelectedMeals = async () => {
    try {
      const response = await Axios.get(`${baseUrl}/report/diet_plan/${date}`, {
        headers: {
          Authorization: `Token ${userToken}`,
        },
      });
      setSelectedMeals(response.data.meals);
      setIsLoading(false);
      setShamsiDate(response.data.dates.current_date);
    } catch (error) {
      console.log("Error during getting selected meals", error);
    }
  };

  useEffect(() => {
    if (
      userToken ||
      isSubmit ||
      location.pathname === "/mealCalorieSelector/1"
    ) {
      fetchSelectedMeals();
    }
  }, [baseUrl, userToken, location.pathname, isSubmit]);

  const saveActions = () => {
    setShowMealEditModal(false);
    setShowAlert(true);
    setAlertText("ویرایش شد");
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    fetchSelectedMeals();
  };

  useEffect(() => {
    if (selectedMeals) {
      setIsLoading(false);
    }
  }, [selectedMeals]);

  const handleRemoveMeal = async (foodId) => {
    try {
      const response = await Axios.get(
        `${baseUrl}/report/diet_plan/${foodId}/remove`,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      if (response.status === 204) {
        const newSelectedMeals = selectedMeals.filter(
          (meal) => meal.id !== foodId
        );
        setSelectedMeals(newSelectedMeals);
        setShowAlert(true);
        setAlertText("حذف شد");
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
      }
    } catch (error) {
      console.log("Error during remove meal", error);
    }
  };

  const handleSubmitModal = () => {
    setIsSubmit(true);
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="mealCalorieHeader centeredFlex">
            <MdArrowForwardIos
              className="mealCalorieArrow"
              onClick={prevMealHandler}
            />
            {activeMealData.length > 0 && (
              <div className="mealData">
                <span>{activeMealData[0].name}</span>
                <img src={activeMealData[0].whiteImg} alt="meal" />
              </div>
            )}
            <MdArrowBackIos
              className="mealCalorieArrow"
              onClick={nextMealHandler}
            />
          </div>

          <div className="MealCalorieSearchBar centeredFlex horizontalBorder">
            <div
              className="searchMethod centeredFlex"
              onClick={openFoodListHandler}
              style={
                location.pathname.includes("foodList")
                  ? {
                      backgroundColor: "#FFF",
                      marginBottom: "-3px",
                      color: "#000",
                    }
                  : {
                      backgroundColor: "transparent",
                      marginBottom: "0",
                      color: "#FFF",
                    }
              }
            >
              <MdSearch style={{ fontSize: "1.3rem" }} />
              <span>جستجو</span>
            </div>
            <div className="searchMethod centeredFlex">
              <img
                src="/images/barcode.svg"
                alt="barcode"
                style={{ width: "1.4rem" }}
              />
              <span>جستجو</span>
            </div>
            <div className="searchMethod centeredFlex">
              <img
                src="/images/flame.svg"
                alt="flame"
                style={{ width: "1.1rem" }}
              />
              <span>جستجو</span>
            </div>
            <div className="searchMethod centeredFlex">
              <img
                src="/images/microphone.svg"
                alt="microphone"
                style={{ width: "0.625rem" }}
              />
              <span>جستجو</span>
            </div>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <ul className="selectedFoods scroll centeredFlex">
              {activeMealData.length > 0 &&
                selectedMeals
                  .filter((meal) => meal.meal_name === activeMealData[0].label)
                  .map((meal) => (
                    <li key={meal.id} className="selectedFood centeredFlex">
                      <div className="selectedFoodRight centeredFlex">
                        <div className="selectedFoodRightBtns centeredFlex">
                          <div className="foodRemoveBtnWrapper centeredFlex">
                            <FaRegTrashAlt
                              className="foodRemoveBtn"
                              onClick={() => handleRemoveMeal(meal.id)}
                            />
                          </div>
                          <div className="foodEditBtnWrapper centeredFlex">
                            <FiEdit2
                              className="foodEditBtn"
                              onClick={() => handleShowEditModal(meal)}
                            />
                          </div>
                        </div>
                        <span className="selectedFoodName">
                          {meal.food.name}
                        </span>
                      </div>
                      <span className="selectedFoodLeft">{meal.calories}</span>
                    </li>
                  ))}
            </ul>
          )}
          <Outlet />
          <div
            className="mealCalorieBottom centeredFlex"
            onClick={openFoodListHandler}
          >
            <AddIcon className="mealCalorieBottomIcon" />
          </div>
          {units && showMealEditModal && (
            <FoodModal
              mealData={mealData}
              show={showMealEditModal && units != null}
              onHideHandle={handleHideEditModal}
              units={units}
              activeUnitId={activeUnitId}
              onActiveUnitId={handleActiveUnitId}
              onSaveActions={saveActions}
              activeMealName={activeMealName}
              shamsiDate={shamsiDate}
              mainId={mainId}
              method="edit"
              editInitAmount={editInitAmount}
              onSubmitted={handleSubmitModal}
            />
          )}
          <Alert showAlert={showAlert} alertText={alertText} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
